import { useContext, useState, useEffect } from "react";
import { doc, updateDoc, getDocs, collection } from "firebase/firestore";
import { fireDB } from "../../firebase/FirebaseConfig";
import MyContext from "../../context/Context";
import Loader from "../../components/Loader/Loader";
import toast from "react-hot-toast";
import MyRaiseProduct from "./MyRaiseProduct";

const UserDashboard = () => {
    const user = JSON.parse(localStorage.getItem("users"));
    const context = useContext(MyContext);
    const { loading, getAllOrder } = context;

    // ✅ State to track cancelled orders from Firestore
    const [orderCancel, setOrderCancel] = useState({});

    // ✅ Fetch cancellation status from Firestore when user logs in
    useEffect(() => {
        const fetchOrderStatus = async () => {
            if (user?.uid) {
                try {
                    const querySnapshot = await getDocs(collection(fireDB, "order"));
                    const cancelStatus = {};
                    querySnapshot.forEach((doc) => {
                        const data = doc.data();
                        if (data.cancel === "cancelled") {
                            cancelStatus[doc.id] = true;
                        }
                    });
                    setOrderCancel(cancelStatus);
                } catch (error) {
                    console.error("Error fetching order status:", error);
                }
            }
        };

        fetchOrderStatus();
    }, [user?.uid]);

    // ✅ Function to handle order cancellation
    const handleCancelOrder = async (orderId) => {
        try {
            const orderRef = doc(fireDB, "order", orderId);

            // ✅ Update Firestore order collection
            await updateDoc(orderRef, {
                cancel: "requested",
            });

            // ✅ Update state based on Firestore
            const updatedOrderCancel = { ...orderCancel, [orderId]: true };
            setOrderCancel(updatedOrderCancel);
            toast.success("Order cancellation requested successfully!");
        } catch (error) {
            console.error("Error cancelling order:", error);
        }
    };

    // ✅ Sorting orders by newest first
    const sortedOrders = getAllOrder
        .filter((obj) => obj.userid === user?.uid)
        .sort((a, b) => new Date(b.date) - new Date(a.date));

    // ✅ Splitting orders into active and canceled
    const activeOrders = sortedOrders.filter((order) => order.cancel !== "cancelled");
    const cancelledOrders = sortedOrders.filter((order) => order.cancel === "cancelled");

    return (
        <div className="container mx-auto px-4 py-5 lg:py-8">

       
            {/* User Details */}
            <div className="top">
                <div className="bg-pink-50 py-5 rounded-xl border border-pink-100">
                    <div className="flex justify-center">
                        <img
                            className="w-20"
                            src="https://t3.ftcdn.net/jpg/05/17/79/88/360_F_517798849_WuXhHTpg2djTbfNf0FQAjzFEoluHpnct.jpg"
                            alt="User"
                        />
                    </div>
                    <div>
                        <h1 className="text-center text-lg">
                            <span className="font-bold">Name:</span> {user?.name}
                        </h1>
                        <h1 className="text-center text-lg">
                            <span className="font-bold">Email:</span> {user?.email}
                        </h1>
                        <h1 className="text-center text-lg">
                            <span className="font-bold">Date:</span> {user?.date}
                        </h1>
                        <h1 className="text-center text-lg">
                            <span className="font-bold">Role:</span> {user?.role}
                        </h1>
                    </div>
                </div>
            </div>

            <div>
         
            </div>

            {/* Active Orders Section */}
            <div className="bottom">
                <div className="mx-auto my-4 max-w-6xl px-2 md:my-6 md:px-0">
                    <h2 className="text-2xl lg:text-3xl font-bold">Order Details</h2>

                    {/* Loader */}
                    <div className="flex justify-center relative top-10">
                        {loading && <Loader />}
                    </div>

                    {/* Active Orders */}
                    {activeOrders.map((order) => (
                        <div key={order.id}>
                            {order.cartItems.map((item) => {
                                const { id, date, quantity, price, title, productImageUrl, category } = item;
                                const { status } = order;

                                return (
                                    <div
                                        key={id}
                                        className="mt-5 flex flex-col overflow-hidden rounded-xl border border-pink-100 md:flex-row"
                                    >
                                        {/* Left Section */}
                                        <div className="w-full border-r border-pink-100 bg-pink-50 md:max-w-xs">
                                            <div className="p-8">
                                                <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-1">
                                                    <div className="mb-4">
                                                        <div className="text-sm font-semibold text-black">Order Id</div>
                                                        <div className="text-sm font-medium text-gray-900">#{id}</div>
                                                    </div>
                                                    <div className="mb-4">
                                                        <div className="text-sm font-semibold">Date</div>
                                                        <div className="text-sm font-medium text-gray-900">{date}</div>
                                                    </div>
                                                    <div className="mb-4">
                                                        <div className="text-sm font-semibold">Total Amount</div>
                                                        <div className="text-sm font-medium text-gray-900">₹ {price * quantity}</div>
                                                    </div>
                                                    <div className="mb-4">
                                                        <div className="text-sm font-semibold">Order Status</div>
                                                        <div className={`text-sm font-medium ${status === "pending" ? "text-red-800" : "text-green-800"}`}>
                                                            {status}
                                                        </div>
                                                    </div>

                                                    {status !== "delivered" && (
                                                        <div className="mb-4">
                                                            <div className="text-sm font-semibold">Order Cancel</div>
                                                            <div className="text-sm font-medium text-red-800">
                                                                {orderCancel[order.id] ? (
                                                                    <button className="bg-red-500 text-white px-3 py-1">
                                                                       {cancel}
                                                                    </button>
                                                                ) : (
                                                                    <button
                                                                        className="bg-red-500 text-white px-3 py-1"
                                                                        onClick={() => handleCancelOrder(order.id)}
                                                                    >
                                                                        Cancel Order
                                                                    </button>
                                                                )}
                                                            </div>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        </div>

                                        {/* Right Section */}
                                        <div className="flex-1 p-8">
                                            <ul className="-my-7 divide-y divide-gray-200">
                                                <li className="flex flex-col justify-between space-x-5 py-7 md:flex-row">
                                                    <div className="flex flex-1 items-stretch">
                                                        <img
                                                            className="h-40 w-40 rounded-lg border border-gray-200 object-contain"
                                                            src={productImageUrl || "/default-image.png"}
                                                            alt={title}
                                                        />
                                                        <div className="ml-5">
                                                            <p className="text-sm font-bold text-gray-900">{title}</p>
                                                            <p className="mt-1.5 text-sm font-medium text-gray-500">{category}</p>
                                                        </div>
                                                    </div>
                                                    <p className="text-right text-sm font-bold text-gray-900">₹ {price}</p>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    ))}
                </div>
            </div>

           
      {/* Cancelled Orders Section */}
{cancelledOrders.length > 0 && (
    <div className="mx-auto my-4 max-w-6xl px-2 md:my-6 md:px-0">
        <h2 className="text-2xl lg:text-3xl font-bold text-red-500">Cancelled Orders</h2>

        {cancelledOrders.map((order) => (
            <div key={order.id}>
                {order.cartItems.map((item) => {
                    const { id, date, quantity, price, title, productImageUrl, category } = item;
                    const { status,cancel } = order;

                    return (
                        <div
                            key={id}
                            className="mt-5 flex flex-col overflow-hidden rounded-xl border border-gray-200 bg-gray-50 md:flex-row"
                        >
                            {/* Left Section */}
                            <div className="w-full border-r border-gray-200 bg-gray-100 md:max-w-xs">
                                <div className="p-8">
                                    <div className="grid grid-cols-1 sm:grid-cols-4 md:grid-cols-1">
                                        <div className="mb-4">
                                            <div className="text-sm font-semibold text-black">Order Id</div>
                                            <div className="text-sm font-medium text-gray-900">#{id}</div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="text-sm font-semibold">Date</div>
                                            <div className="text-sm font-medium text-gray-900">{date}</div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="text-sm font-semibold">Total Amount</div>
                                            <div className="text-sm font-medium text-gray-900">₹ {price * quantity}</div>
                                        </div>
                                        <div className="mb-4">
                                            <div className="text-sm font-semibold">Order Status</div>
                                            <div className="text-sm font-medium text-red-800">{cancel}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Right Section */}
                            <div className="flex-1 p-8">
                                <ul className="-my-7 divide-y divide-gray-200">
                                    <li className="flex flex-col justify-between space-x-5 py-7 md:flex-row">
                                        <div className="flex flex-1 items-stretch">
                                            <img
                                                className="h-40 w-40 rounded-lg border border-gray-200 object-contain"
                                                src={productImageUrl || "/default-image.png"}
                                                alt={title}
                                            />
                                            <div className="ml-5">
                                                <p className="text-sm font-bold text-gray-900">{title}</p>
                                                <p className="mt-1.5 text-sm font-medium text-gray-500">{category}</p>
                                            </div>
                                        </div>
                                        <p className="text-right text-sm font-bold text-gray-900">₹ {price}</p>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    );
                })}
            </div>
        ))}
    </div>
)}

        </div>
    );
};

export default UserDashboard;
